import React from 'react';
import { useTranslation } from 'react-i18next';
import UserCircle from 'apollo-react-icons/UserCircle';
import DataTableComponent from '../DataTable/PrimeDataTable';
import styles from './AssessmentStatusTable.module.css';
import AssessmentStatusBadge from './AssessmentStatusBadge';

const ReviewerInfo = ({ name }) => (
  <div className={styles.reviewerContainer}>
    <UserCircle size={24} color="#6b7280" />
    <span>{name}</span>
  </div>
);

export default function AssessmentStatusTable({ data = [], onRowClick }) {
  const { t } = useTranslation();

  const columns = [
    {
      field: 'reviewerName',
      header: t('name'),
      body: (row) => <ReviewerInfo name={row.reviewerName} />,
    },
    {
      field: 'assessmentStatus',
      header: t('status'),
      body: (row) => <AssessmentStatusBadge status={row.assessmentStatus} />,
    },
  ];

  const handleRowClick = (rowData) => {
    if (onRowClick) onRowClick(rowData.data);
  };

  return (
    <DataTableComponent
      data={data}
      columns={columns}
      enablePagination={false}
      totalRecords={data.length}
      onRowClick={handleRowClick}
      rowClassName={() => 'clickable-row'}
    />
  );
}
